export default {
  colors: {
    white: '#FFFFFF',
    black: '#000000',
    gray: '#A2AAAD',
    blueGray: '#1F2A44',
    transparent: 'transparent',
    lightGray: '#D8DAD9',
    lightenGray: '#f7f7f7',
    blue: '#004F71',
    lightBlue: '#4F758B',
    orange: '#ffa500',
    gold: '#b4975a',
    darkGold: '#9F8550',
    yellow: '#B7BF10',
    green: '#719949',
    navy: '#00234B',
    lighterGray: '#fafafa',
    darkGray: '#333333',
    red: '#CC0000'
  },
  fonts: {
    NunitoSans: "'Nunito Sans', sans-serif;",
    SourceSerifPro: "'Source Serif Pro', sans-serif;",
    OswaldCondensed: "'Oswald Condensed', sans-serif;"
  }
}
